import {
  getAccountId,
  getAccountState,
  getUserRole,
  getUserId,
} from 'src/redux/fe-data/selectors';
import config from 'src/config/app';

/* eslint-disable-next-line import/prefer-default-export */
export const generateSegmentProperties = state => properties => ({
  ...properties,
  groupId: getAccountId(state),
  userId: getUserId(state),
  account_state: getAccountState(state),
  user_role: getUserRole(state),
  nurtureBarVersion: String(config.SEGMENT_TRACK_VERSION),
});
